// @flow
import React from 'react'
import Image from 'next/legacy/image'

interface Props {
  className?: string
  width?: number | string
  height?: number | string
}

const HiresBadge = ({ className = '', width = 60, height = 15 }: Props) => (
  <div className={className}>
    <Image
      src="/static/images/hires-badge.svg"
      width={Number(width)}
      height={Number(height)}
      alt="Hi-Res Audio"
    />
  </div>
)

export default HiresBadge
